import { useState } from 'react'
import { calculatePasswordStrength } from '../../common/helpers'
import { FormikHelpers } from 'formik'
import { useAuth } from '../../common/context'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { alertNotification } from '../../ui'

interface Values {
  newPassword: string,
  confirmPassword: string
}

interface State {
  error?: string
  success?: string
  bar: {
    strengthColor: string
    value: number
  }
}

export const initialValues: Values = {
  newPassword: '',
  confirmPassword: ''
}

export const validate = (values: Values) => {
  const errors: Partial<Values> = {}
  let bar = {
    strengthColor: 'disabled',
    value: 0
  }
  if (!values.newPassword) {
    errors.newPassword = 'Required'
  } else {
    const { error, bar: barState } = calculatePasswordStrength(values.newPassword)
    if (error) {
      errors.newPassword = error
    }
    bar = barState
  }

  if (values.confirmPassword !== values.newPassword) {
    errors.confirmPassword = 'Passwords do not match'
  }

  return { errors, bar }
}

const ResetPassword = () => {
  const { resetPassword } = useAuth()

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const username = searchParams.get('user_name')
  const confirmationCode = searchParams.get('confirmation_code')

  const invalidURL = !(username && confirmationCode)

  const [state, setState] = useState<State>({
    error: undefined,
    success: undefined,
    bar: {
      strengthColor: 'disabled',
      value: 0
    }
  })

  const onSubmit = async (values: Values, { setSubmitting }: FormikHelpers<Values>) => {
    const { newPassword } = values

    try {
      await resetPassword(username as string, confirmationCode as string, newPassword)
      navigate('/login')
      setSubmitting(false)
      alertNotification('Your password has been reset successfully.', 'success')
    } catch (err) {
      setState({ ...state, error: (err as Error).message, success: undefined })
      setSubmitting(false)
    }
  }

  return { state, setState, onSubmit, invalidURL }
}

export default ResetPassword
